import type { ReactNode } from 'react';
import { styleVars } from '../lib/style.ts';
import './row-chip.css';

export interface RowChipProps {
  children: ReactNode;
  tint?: 'cyan' | 'pink' | 'amber' | 'green' | 'neutral';
  size?: number;
}

/** Tinted glyph chip that leads file, folder and compact data rows. */
export function RowChip({ children, tint = 'cyan', size = 32 }: RowChipProps) {
  return (
    <span
      className="rowChip"
      data-tint={tint}
      style={styleVars({ '--row-chip-size': `${size}px` })}
    >
      {children}
    </span>
  );
}
